import { z } from 'zod';
import { evaluationScopeSchema, evaluationStatusSchema } from '../enums.js';
/**
 * Métriques de détection (ADR-0014, Phase A). Calculées par le worker sur un jeu de validation
 * (les annotations validées d'un périmètre), partagées telles quelles avec l'UI qui les affiche.
 *
 * `ap` (average precision par classe) et `mAP` (sa moyenne) sont les métriques de référence en
 * détection d'objets ; `tp/fp/fn` par classe tiennent lieu de matrice de confusion résumée.
 */
export const classMetricsSchema = z.object({
    label: z.string(),
    gtCount: z.number().int().nonnegative(),
    tp: z.number().int().nonnegative(),
    fp: z.number().int().nonnegative(),
    fn: z.number().int().nonnegative(),
    precision: z.number().min(0).max(1),
    recall: z.number().min(0).max(1),
    ap: z.number().min(0).max(1),
});
export const detectionMetricsSchema = z.object({
    imageCount: z.number().int().nonnegative(),
    iouThreshold: z.number().min(0).max(1),
    confidenceThreshold: z.number().min(0).max(1),
    tp: z.number().int().nonnegative(),
    fp: z.number().int().nonnegative(),
    fn: z.number().int().nonnegative(),
    precision: z.number().min(0).max(1),
    recall: z.number().min(0).max(1),
    f1: z.number().min(0).max(1),
    mAP: z.number().min(0).max(1),
    perClass: z.array(classMetricsSchema),
});
/** Requête d'évaluation d'un modèle sur une vidéo (FR-39). Seuils optionnels (défauts raisonnables). */
export const evaluateModelSchema = z.object({
    videoId: z.string().cuid2(),
    iouThreshold: z.number().min(0.1).max(0.95).default(0.5),
    confidenceThreshold: z.number().min(0).max(0.95).default(0.25),
});
export const evaluationRunSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    modelId: z.string(),
    scopeType: evaluationScopeSchema,
    scopeId: z.string(),
    status: evaluationStatusSchema,
    iouThreshold: z.number(),
    confidenceThreshold: z.number(),
    imageCount: z.number().int().nonnegative(),
    metrics: detectionMetricsSchema.nullable(),
    failureReason: z.string().nullable(),
    createdById: z.string().nullable(),
    createdByName: z.string().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
//# sourceMappingURL=evaluation.js.map